<template>
  <ion-avatar class="avatar">
    <custom-img
      class="avatar__image"
      :image="image"
      :imageDefault="DEFAULT_USER_AVARTAR"
      :imagePath="IMAGE_PATH.USER"
    />
  </ion-avatar>
</template>
<script>
import { DEFAULT_USER_AVARTAR, IMAGE_PATH } from '@/modules/b2b/constants';
import { defineComponent } from 'vue';
import CustomImg from '@/components/atoms/image/Image.vue';
export default defineComponent({
  props: {
    image: {
      type: String
    }
  },
  components: {
    CustomImg
  },
  setup() {
    return { IMAGE_PATH, DEFAULT_USER_AVARTAR };
  }
});
</script>
<style lang="scss" scoped>
.avatar {
  width: auto;
  height: auto;
  &__image {
    width: 40px;
    height: 40px;
  }
}
</style>
